// extracted by mini-css-extract-plugin
export var entityChip = "_si-0";
export var entityChipMissing = "_si-1";